/* eslint-disable */
import Vue from 'vue'
export default new Vue()
/* eslint-enable */